import React from "react";

import { MdmObjectDto, ObjectType, useCreateObjectMutation } from "gql/generated/types";
import { useParams } from "react-router-dom";
import { T } from "services/lang/LanguageService";
import ObjectForm from "../components/ObjectForm";
import { apolloErrorToaster, successToaster } from "../utils/utils";

type NewObjectFormProps = {
  objectType: ObjectType;
};

const NewObjectForm: React.FC<NewObjectFormProps> = ({ objectType }) => {
  const { projectId } = useParams();
  const [createObjectMutation, { loading }] = useCreateObjectMutation({
    onCompleted: () => {
      successToaster(T("alert.object-updated-successfully"));
    },
    onError: apolloErrorToaster,
  });

  const handleCreate = (object: MdmObjectDto) => {
    createObjectMutation({
      variables: { object: { ...object, projectId } },
    });
  };

  return <ObjectForm object={null} onSubmit={handleCreate} loading={loading} objectType={objectType} />;
};

export default NewObjectForm;
